import { useState } from "react";
import { motion, AnimatePresence, mmEase } from "@/lib/motion";
import { ArrowRight } from "lucide-react";

const ez = mmEase.expo;
const SYMBOLS = ["₦", "£", "$", "€"];

export default function FloatingCurrencyButton({ onClick, label, "data-testid": testId }) {
  const [floats, setFloats] = useState([]);

  const handleEnter = () => {
    const next = SYMBOLS.map((sym, i) => ({
      id: Date.now() + i,
      sym,
      x: (Math.random() - 0.5) * 60,
    }));
    setFloats(next);
    setTimeout(() => setFloats([]), 900);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }} onMouseEnter={handleEnter}>
      <AnimatePresence>
        {floats.map((f, i) => (
          <motion.span
            key={f.id}
            initial={{ opacity: 0.85, y: 0,   scale: 0.9, x: f.x }}
            animate={{ opacity: 0,    y: -52, scale: 1.1, x: f.x + (Math.random() - 0.5) * 14 }}
            transition={{ duration: 0.72, ease: ez, delay: i * 0.07 }}
            style={{
              position: "absolute", top: "-4px", left: "50%",
              fontSize: "14px", color: "var(--mm-emerald)", fontWeight: 700,
              pointerEvents: "none", zIndex: 100, userSelect: "none",
            }}
          >
            {f.sym}
          </motion.span>
        ))}
      </AnimatePresence>

      <motion.button
        data-testid={testId}
        onClick={onClick}
        whileHover={{ scale: 1.04, y: -2 }}
        whileTap={{ scale: 0.97 }}
        transition={{ duration: 0.2, ease: ez }}
        className="btn-primary-lg inline-flex items-center gap-2"
      >
        {label} <ArrowRight size={14} strokeWidth={2.5} />
      </motion.button>
    </div>
  );
}
